import { GetBackupChecksProps } from "@/services/backup-checks.service";
import { formatCurrencyInputToNumber } from "@/utils/query-string";
import { FieldValues } from "react-hook-form";

const hasFilterValue = (value: unknown) => {
  if (value === undefined || value === null) return false;
  if (Array.isArray(value)) return value.length > 0;
  if (typeof value === "string") return value.trim().length > 0;
  return true;
};

export const getBackupChecksFilter = (event: FieldValues): Partial<GetBackupChecksProps> => {
  const filterObj: Partial<GetBackupChecksProps> = {};
  let amount: number | undefined;

  if (event?.backup_amount) {
    const num = formatCurrencyInputToNumber(event.backup_amount);

    if (!Number.isNaN(num)) {
      amount = num;
    }
  }


  if (hasFilterValue(event?.backup_date)) {
    filterObj.fecha= event.backup_date;
  }
  if (hasFilterValue(event?.account_number)) {
    filterObj.nroCuenta = event.account_number.value;
  }
  if (hasFilterValue(event?.backup_amount)) {
    filterObj.monto= amount;
  }
  if (hasFilterValue(event?.backup_requester)) {
    filterObj.solicitante= event.backup_requester;
  }
  if (hasFilterValue(event?.estados)) {
    filterObj.estados = event.estados;
  }

  return filterObj;
};